import type { MouseEvent } from "react";

/** Closes a modal <dialog> when its backdrop (the area outside the box) is clicked. */
export function closeOnBackdrop(event: MouseEvent<HTMLDialogElement>): void {
  const dialog = event.currentTarget;
  if (event.target !== dialog) return; // a click inside the content
  const box = dialog.getBoundingClientRect();
  const inside =
    event.clientX >= box.left &&
    event.clientX <= box.right &&
    event.clientY >= box.top &&
    event.clientY <= box.bottom;
  if (!inside) dialog.close();
}
